<template id="dialogTmpl" >
	<v-dialog v-model="$root.dialogMsgOpen" width="500" >
		<v-card>
			<v-card-text>
				<div class="dialogMsg">{{$root.dialogMsg}}</div>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn class="button-main" @click="$root.dialogMsgOpen = false" >OK</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import i18n from '@/i18n';
export default {
	i18n,
};
</script>